/**
 * Created by eliasmj on 21/09/2015.
 */
angular.module('qkr.mssConfig')
    .controller('MssConfigController', function(mssConfigService, $location, $scope, Upload, appConfig, $timeout) {
    const self = this;

    mssConfigService.getTranslationsReports().then((response) => {
        self.translationsReports = response;
    }, (reason) => {
        console.error(reason);
    });

    self.setMessages = function(messages) {
        mssConfigService.setCurrentMessages(messages);

        self.messages = mssConfigService.getCurrentMessages();

        $location.path('/mssconfig/messages/details');
    };

    $scope.uploadFile = function(file) {
        $scope.f = file;
        $scope.errorMsg = null;

        if (file && !file.$error) {
            file.upload = Upload.upload({
                url: appConfig.contextPath + '/config/createHotTranslationFile',
                file
            });

            file.upload.then((response) => {
                $timeout(() => {
                    file.result = response.data;
                });
            }, (reason) => {
                if (reason.status !== 200) {
                    $scope.errorMsg = reason.status + ': ' + reason.data.exception;
                }
            });

            file.upload.progress((evt) => {
                file.progress = Math.min(100, parseInt(100.0 *
                    evt.loaded / evt.total));
            });
        }
    };
});



// WEBPACK FOOTER //
// ./src/mssConfig/controllers/mssConfigController.js